export default __webpack_public_path__ + "static/media/XEMP-9.349bfb31.jpg";